<template>
  <BankUpdateRequestsList />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import BankUpdateRequestsList from '@/components/bank-update-requests/BankUpdateRequestsList.vue';

export default defineComponent({
  name: 'BankUpdateRequestsPage',
  components: {
    BankUpdateRequestsList
  }
});
</script>
